import { API_URL } from './Constants';
import ApiService from './ApiService';

class AudioPageApi {
    static getChitietVideo = async (postId) => {
        try {
            let params = {};
            if (postId !== null) {
                params = { postId };
            }
            return await ApiService.getDataWithParams(API_URL + "/audio/detail", params);
        } catch (error) {
        }
    };

    static getAudioMoiNhat = async (pageNumber) => {
        try {
            let params = {};
            if (pageNumber !== null) {
                params = { pageNumber };
            }
            return await ApiService.getDataWithParams(API_URL + "/audio/new-audio", params);
        } catch (error) {
        }
    };

    static getAudioXemNhieu = async (pageNumber) => {
        try {
            let params = {};
            if (pageNumber !== null) {
                params = { pageNumber };
            }
            return await ApiService.getDataWithParams(API_URL + "/audio/top-view", params);
        } catch (error) {
        }
    };

    static getAudioTaiNhieu = async (pageNumber) => {
        try {
            let params = {};
            if (pageNumber !== null) {
                params = { pageNumber };
            }
            return await ApiService.getDataWithParams(API_URL + "/audio/top-download", params);
        } catch (error) {
        }
    };

     // --------------- ADMIN -----------------
     static listFtpFiles = async (directory) => {
         try {
             let params = {};
             if (directory) {
                 params = { directory };
             }
             return await ApiService.getDataWithParams(API_URL + "/upload/ftp/list", params);
         } catch (error) {
             console.error('Error listing FTP files:', error);
             return [];
         }
     };

     static listFtpDirectories = async (directory) => {
         try {
             let params = {};
             if (directory) {
                 params = { directory };
             }
             return await ApiService.getDataWithParams(API_URL + "/upload/ftp/directories", params);
         } catch (error) {
             console.error('Error listing FTP directories:', error);
             return [];
         }
     };

     static submitPost = async (formData) => {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("seoUrl", formData.seoUrl);
        data.append("nguoiGiang", formData.nguoiGiang);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        if (formData.file) {
            data.append("file", formData.file);
        }
        if (formData.linkMp3) {
            data.append("ftpFilePath", formData.linkMp3);
        } else if (formData.ftpFilePath) {
            data.append("ftpFilePath", formData.ftpFilePath);
        }
        if (formData.image) {
            data.append("image", formData.image);
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }
        try {
            const response = await ApiService.postFormData(API_URL + "/audio/create", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static updatePost = async (formData) => {
        const data = new FormData();
        data.append("postId", formData.postId);
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("seoUrl", formData.seoUrl);
        data.append("nguoiGiang", formData.nguoiGiang);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        data.append("isDeleteFile", formData.isDeleteFile || false);
        data.append("isDeleteImage", formData.isDeleteImage || false);
        if (formData.file) {
            data.append("file", formData.file);
        }
        if (formData.linkMp3) {
            data.append("ftpFilePath", formData.linkMp3);
        } else if (formData.ftpFilePath) {
            data.append("ftpFilePath", formData.ftpFilePath);
        }
        if (formData.image) {
            data.append("image", formData.image);
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }
        try {
            const response = await ApiService.postFormData(API_URL + "/audio/update", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static getChiTietAudioAdmin = async (postId, postType) => {
        try {
            let params = { postId, postType };

            console.log(params)

            return await ApiService.getDataWithParams(API_URL + "/audio/admin/detail", params);
        } catch (error) {
        }
    };
}
export default AudioPageApi;